import React, { useRef, useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";

import "./UniversalGreetingPage.css";
import LeftTree from "../../images/universalPage/LeftTree.png";
import RightTree from "../../images/universalPage/RightTree.png";
import {
  PhotoSection,
  CardStyleSection,
  ImageGenerationSection,
  GreetingSubjectSection,
  GenderAgeSection,
  HobbiesSection,
  TraitsSection,
  GreetingTextSection,
} from "../../components/sections";
import { cardStyleOptionNewYear } from "../../data/options";
import { useFormData } from "../../utils/formHandlers";
import BackgroundsSection from "../../components/sections/BackgroundsSection/BackgroundsSection";
import { StylizePhotoForPostcardApiSetting } from "../../prompts/replicate/StylizePhotoForPostcardPrompt";
import { PersonSection } from "../../components/sections/PersonSection/PersonSection";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";



export const UniversalGreetingPage = () => {
  const [showGreeting, setShowGreeting] = React.useState(false);
  const [generatedImageUrl, setGeneratedImageUrl] = useState("");
  const [generatedPrompt, setGeneratedPrompt] = useState("");

  const navigate = useNavigate();

  const handleShowGreeting = () => {
    setShowGreeting(true);
  };

  const handleImageGenerated = (key, value) => {
    console.log('StylizePhotoForPostcard - handleImageGenerated:', { key, value });
    if (!key) return;
    if (key === "finalGeneratedImageUrl" || key === "imageUrl") {
      setGeneratedImageUrl(value);
      console.log('StylizePhotoForPostcard - встановлено generatedImageUrl:', value);
    }
    if (key === "generatedImagePrompt") {
      setGeneratedPrompt(value);
    }
  };

  // Ref для доступу до функції generateImage з ImageGenerationSection
  const generateImageRef = useRef(null);

  // Створюємо refs для кожної секції
  const styleRef = useRef(null);
  const photoRef = useRef(null);
  const imageGenerationRef = useRef(null);
  const greetingSubjectRef = useRef(null);
  const genderAgeRef = useRef(null);
  const personRef = useRef(null);
  const hobbiesRef = useRef(null);
  const traitsRef = useRef(null);
  const greetingTextRef = useRef(null);

  // Масив refs для зручності навігації (в порядку відображення на сторінці)
  const sectionRefs = [
    photoRef,           // 0 - PhotoSection
    styleRef,           // 1 - CardStyleSection
    imageGenerationRef, // 2 - ImageGenerationSection
    greetingSubjectRef, // 3 - GreetingSubjectSection (показується після onShowGreeting)
    genderAgeRef,       // 4 - GenderAgeSection
    personRef,          // 5 - PersonSection  
    hobbiesRef,         // 6 - HobbiesSection
    traitsRef,          // 7 - TraitsSection
    greetingTextRef,    // 8 - GreetingTextSection
  ];

  const { formData, updateField } = useFormData({
    cardStyle: "",
    cardMood: "",
    background: "",
    photo: null,
    gender: "",
    age: "",
    hobby: "",
    greetingText: "",
    greetingSubject: "",
    trait: "",
    generatedImagePrompt: "",
    imageUrl: "",
  });

  const handleFieldChange = (field, value) => {
    updateField(field, value);
  };



  return (
     <div>  
   {/* <Header /> */}
    <div className="main-dalle-first-image">
       
        <div className="form-header">
          <h1>
           Create a New Year card
          </h1>
          <div className="arrow-down">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 8 L36 8 L36 20 L42 20 L24 36 L6 20 L12 20 L12 8 Z" fill="#ffffff"/>
            </svg>
          </div>
       
  </div>
   
      <PhotoSection
        ref={photoRef}
        title="Add a photo of one person or pet"
        description={
          <>
            Додайте фото <strong>однієї</strong> людини або домашнього улюбленця.
          </>
        }
        onPhotoChange={handleFieldChange}
        showChristmasDecoration={true}
        leftTreeSrc={LeftTree}
        rightTreeSrc={RightTree}
      />
           
        <CardStyleSection
        ref={styleRef}
        onStyleChange={handleFieldChange}
        styleOptions={cardStyleOptionNewYear}
      />

   
      <ImageGenerationSection
        ref={imageGenerationRef}
        onImagePromptChange={handleFieldChange}
        onImageUrlChange={handleFieldChange}
        formData={formData}
        generateImageData={StylizePhotoForPostcardApiSetting(formData)}
        generateImageRef={generateImageRef}
        onShowGreeting={handleShowGreeting}
        onImageGenerated={handleImageGenerated}
        hideBackgroundStep={true}
        useChristmasPrompt={true}
        useDirectPrompt={true}
      />
      {showGreeting && (
        <div className="greeting-subject-section">
          <GreetingSubjectSection
            ref={greetingSubjectRef}
            onSubjectChange={handleFieldChange}
          />
          <GenderAgeSection
            ref={genderAgeRef}
            onGenderChange={handleFieldChange}
            onAgeChange={handleFieldChange}
          />
          <PersonSection
            ref={personRef}
            onPersonChange={handleFieldChange}
            selectedGender={formData.gender}
          />
          <HobbiesSection
            ref={hobbiesRef}
            onHobbyChange={handleFieldChange}
          />
          <TraitsSection
            ref={traitsRef}
            onTraitChange={handleFieldChange}
          />

          <GreetingTextSection
            ref={greetingTextRef}
            onTextChange={handleFieldChange}
            formData={formData}
            generatedImageUrl={generatedImageUrl}
            navigate={navigate}
          />
        </div>
      )}
    
    </div>
   {/* <Footer /> */}

   </div>
  );
};
